import React from 'react'
import 'styles/footer.scss'

function Footer(props) {
  return (
    <div className="footerWrap">
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            &copy; 1996-{new Date().getFullYear()} Shaadi.com, The World's No.1
            Matchmaking Service&trade;
          </div>
          <div className="col-md-4 createdBy">
            Passionately created by{' '}
            <a
              href="http://people-group.com"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              People Group
              <span className="rightSmallArrow" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
